import safetyDefaultAPI from '../../api';
import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';

const getDamageReport = async ({ seq }) => {
  try {
    const response = await safetyDefaultAPI.get(`damage-report/${seq}`);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getDamageReport;
